import React, { useCallback, useState } from 'react';
import { SearchField } from './SearchField';
import { Button } from '../../atoms/Button';
import { makeCSS } from '../../../utils/makeCSS';

const useStyles = makeCSS(({ theme }) => ({
  replyButtonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '16px',
    gap: 8
  }
}));

interface Props {
  onSave: (msg: string) => void;
}
export const ReplyField = (props: Props) => {
  const { onSave } = props;
  const classes = useStyles();
  const [replyInput, setReplyInput] = useState('');

  const onChange = useCallback((e) => setReplyInput(e.target.value), []);
  const onSendReply = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!replyInput) {
        return;
      }
      onSave(replyInput);
      setReplyInput('');
    },
    [onSave, replyInput]
  );

  const onCancelReply = useCallback((e) => {
    e.stopPropagation();
    setReplyInput('');
  }, []);

  return (
    <form onSubmit={onSendReply}>
      <div style={{ borderRadius: 6 }}>
        <SearchField
          startAdornment={<div style={{ width: 4 }} />}
          value={replyInput}
          onChange={onChange}
          placeholder="Add your thoughts..."
          multiline={true}
        />
      </div>

      {replyInput && (
        <div className={classes.replyButtonGroup}>
          <Button
            background="secondary"
            buttonStyle="ghost"
            onClick={onCancelReply}
            label={'Cancel'}
          />
          <Button
            background="secondary"
            buttonStyle="solid"
            onClick={onSendReply}
            label={'Post'}
          />
        </div>
      )}
    </form>
  );
};
